import createReactClass from 'create-react-class';
import moment from 'moment';
import React from 'react';
import { outageStore } from '../stores/outage';

function getStateFromStores() {
    return {
        showBanner: outageStore.isShowingBanner(),
        showOutage: outageStore.isShowingOutage(),
        outage: outageStore.getCurrentOutage()
    }
}

var OutageView = createReactClass({
    componentDidMount: function () {
        outageStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        outageStore.unsubscribe(this._onChange);
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    render: function () {

        var content = "";
        if (this.state.outage) {
            var startTime = moment(this.state.outage.outageStartDateTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm ddd MM-DD-YY");
            var endTime = moment(this.state.outage.outageEndDateTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm ddd MM-DD-YY");
        }


        if (this.state.showBanner) {
            content = (
                <div className="bannerDiv">
                    An outage is scheduled to start at {startTime} and run until {endTime}. Please plan your work
                    accordingly.
                </div>)
        }
        else if (this.state.showOutage) {
            var outage = this.state.outage;
            content = (
                <div className="outageBlock">
                    <div style={{ "textAlign": "center" }}>
                        <h1>GRIT - Scheduled Maintenance</h1>

                        <h3>
                            You are seeing this screen because GRIT is in a scheduled outage and is currently
                            unavailable.
                        </h3>

                        <h3>
                            Outage Details:<br />
                            Scheduled Start Date: {startTime}<br />
                            Scheduled End Date: {endTime}<br />
                            Message:{outage.outageMessage}<br />
                        </h3>

                        <p>
                            Please try again after {endTime}
                        </p>
                    </div>
                </div>)
        }

        return (
            <div >
                {content}
            </div>
        );
    }
});



export default OutageView;